import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
// import InsertDriveIcon from '@material-ui/icons/InsertDriveFile';

import ConfirmationModal from 'components/threepp/ConfirmationModal/ConfirmationModal';
import { htmlToReact } from 'utils/functions';
import { CommentInput } from './CommentInput';
import { CommentActions } from './CommentActions';
import { CommentHOC } from './Comment';
import CommentHeader from './CommentHeader';

const useStyles = makeStyles(theme => ({
  commentHeader: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  commentBox: {
    marginLeft: '2.75rem'
  },
  commentText: {
    marginRight: theme.whitespace.more,
    '& p': {
      marginBottom: '0.75rem'
    }
  },
  fileIcon: {
    color: '#616161',
    marginRight: theme.whitespace.least,
    fontSize: '1.125rem'
  },
  attachment: {
    display: 'inline-block',
    textDecoration: 'underline',
    marginRight: theme.whitespace.base,
    overflowWrap: 'break-word'
  }
}));

export const MobileCommentBase = props => {
  const [showActions, setShowActions] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const { comment, translate, commentMetadata, sourceFieldId, updateCommentsState, removeCommentMethod, currentUser, isAssessmentReadOnly } = props;
  const classes = useStyles();

  const onDeleteHandler = () => {
    setShowActions(false);
    setShowConfirmDeleteModal(true);
  };

  const onEditHandler = () => {
    setShowActions(false);
    setEditMode(true);
  };

  const onCloseModal = () => setShowConfirmDeleteModal(false);

  const onConfirmDelete = () => {
    removeCommentMethod(comment);
    setShowConfirmDeleteModal(false);
  };

  const onCancel = () => {
    setEditMode(false);
    setShowActions(true);
  };

  const isActionsVisible = !comment?.is_read_only && currentUser.email === comment.comment_user.email && !isAssessmentReadOnly;

  const commentBox = (
    <div className={classes.commentBox}>
      <div className={classes.commentText}>{htmlToReact(comment.comment_text)}</div>
      {/* {comment?.attachments?.map(attachment => (
        <div key={attachment.filename} className={classes.attachment}>
          <InsertDriveIcon className={classes.fileIcon} />
          {attachment.filename}
        </div>
      ))} */}
    </div>
  );

  const actions = isActionsVisible && <CommentActions showActions={showActions} onEdit={onEditHandler} onDelete={onDeleteHandler} />;

  return (
    <div onFocus={() => setShowActions(!editMode)} onMouseOver={() => setShowActions(!editMode)} onMouseLeave={() => setShowActions(false)}>
      <ConfirmationModal
        title={translate('comments.deleteComment.title')}
        message={translate('comments.deleteComment.prompt')}
        cancelButtonText={translate('common.cancel')}
        confirmButtonText={translate('common.delete')}
        isOpen={showConfirmDeleteModal}
        onConfirm={onConfirmDelete}
        onCancel={onCloseModal}
      />
      <div className={classes.commentHeader}>
        <CommentHeader actions={actions} commentUser={comment.comment_user} lastUpdated={comment.last_updated} />
      </div>
      {editMode && (
        <CommentInput
          editMode={editMode}
          comment={comment}
          onCancel={onCancel}
          commentMetadata={commentMetadata}
          sourceFieldId={sourceFieldId}
          updateCommentsState={updateCommentsState}
          isAssessmentReadOnly={isAssessmentReadOnly}
        />
      )}
      {!editMode && commentBox}
    </div>
  );
};

export const MobileComment = CommentHOC(MobileCommentBase);
